import React from "react";
import { FaBolt, FaHeartbeat, FaSmile, FaTrophy } from "react-icons/fa";
import { motion } from "framer-motion"; // Import motion from Framer Motion

const Timeline = () => {
  return (
    <div className="bg-[#f5ebdc] text-white p-8">
      <h1 className="text-4xl font-bold text-center mb-8 text-[#313131]">
        Efekty Treningu EMS
      </h1>

      <div className="relative">
        {/* Line connecting the boxes */}
        <div className="hidden md:block absolute top-1/2 left-0 transform -translate-y-1/2 h-1 w-full bg-orange-500"></div>
        <div className="block md:hidden absolute left-1/2 top-0 transform -translate-x-1/2 h-full w-1 bg-orange-500"></div>

        <div className="flex flex-col md:flex-row items-center md:space-x-12 space-y-12 md:space-y-0 mt-[100px]">
          {/* Timeline items */}
          {[
            {
              title: "Zwiększona Energia",
              description: "Pierwsze efekty zauważalne już po kilku sesjach.",
              icon: <FaBolt className="text-4xl text-orange-500" />,
            },
            {
              title: "Poprawa Kondycji",
              description: "Wzmocnienie mięśni i poprawa wydolności organizmu.",
              icon: <FaHeartbeat className="text-4xl text-red-500" />,
            },
            {
              title: "Lepsze Samopoczucie",
              description: "Redukcja stresu i zwiększenie endorfin.",
              icon: <FaSmile className="text-4xl text-yellow-500" />,
            },
            {
              title: "Osiągnięcie Celów",
              description: "Widoczne rezultaty w krótkim czasie.",
              icon: <FaTrophy className="text-4xl text-green-500" />,
            },
          ].map((item, index) => (
            <motion.div
              key={index}
              className="relative bg-[#232323] p-6 rounded-lg shadow-md w-3/4 md:w-1/4 text-center"
              initial={{ opacity: 0, y: 20 }} // Initial state
              animate={{ opacity: 1, y: 0 }} // Animate to this state
              transition={{ duration: 0.5, delay: index * 0.1 }} // Transition properties
            >
              <div className="border-2 absolute -top-6 left-1/2 transform -translate-x-1/2 flex justify-center items-center bg-gray-900 w-12 h-12 rounded-full">
                {item.icon}
              </div>
              <h2 className="text-lg font-semibold mt-6 text-[#f5ebdc]">
                {item.title}
              </h2>
              <p className="text-sm mt-2 text-[#f5ebdc]">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Timeline;
